import { Label } from "components/atoms";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";
import {
  PiNotepad,
  PiSeal,
  PiSealCheck,
  PiSealQuestion,
  PiSealWarning,
  PiX,
} from 'react-icons/pi';
import { LABEL_STATUS } from 'services/labels/types';
import { IColorProp } from 'types/components/components.interface';

export interface ILabeledLabelStatusProps<T = LABEL_STATUS> {
  status: T;
}

export interface ILabeledLabelStatusParams<T = LABEL_STATUS> extends IColorProp {
  status: T;
  icon: ReactNode;
}

const labeledLabelStatusParams: ILabeledLabelStatusParams[] = [
  {
    status: LABEL_STATUS.Draft,
    color: "black",
    icon: <PiNotepad />,
  },
  {
    status: LABEL_STATUS.NotVerified,
    color: "red",
    icon: <PiSealWarning />,
  },
  {
    status: LABEL_STATUS.DuringVerification,
    color: "orange",
    icon: <PiSeal />,
  },
  {
    status: LABEL_STATUS.Verified,
    color: "green",
    icon: <PiSealCheck />,
  },
  {
    status: LABEL_STATUS.Banned,
    color: "red",
    icon: <PiX />,
  },
];

const LabeledLabelStatus = ({ status }: ILabeledLabelStatusProps) => {
  const { t } = useTranslation();
  const labeledParams =
    labeledLabelStatusParams.find((params) => params.status === status) ??
    labeledLabelStatusParams[0];
  return (
    <Label
      size="compact"
      color={labeledParams.color}
      title={t(`enum.LABEL_STATUS.${LABEL_STATUS[labeledParams.status]}`)}
    >
      {labeledParams.icon} {t(`enum.LABEL_STATUS.${LABEL_STATUS[labeledParams.status]}`)}
    </Label>
  );
};

export default LabeledLabelStatus;
